/**
 * Check if hours are valid
 * @param {Object} hours - Hours object
 * @returns {boolean} - True if hours are valid (has at least one non-null value)
 */
export const hasValidHours = (hours) => {
	if (!hours || Object.keys(hours).length === 0) {
		return false;
	}

	return Object.values(hours).some((hourValue) => hourValue != null);
};
